import React, { Component } from 'react'
import PropTypes from 'prop-types'

import SidePanel from './SidePanel'
import Logo from './SidePanel/logo.js'

class ForgotPasswordSuccess extends Component {
  static propTypes = {
    history: PropTypes.object
  }

  render () {
    return (
      <div className='auth'>
        <SidePanel />
        <div className='expert-form-login'>
          <Logo className='auth-form-logo' />
          <div className='expert-form-login__title'>Forgot your password?</div>
          <div className='expert-form__label--black'>
            Please check your email and follow the instructions to retrieve your
            password.
          </div>
          <div
            className='link m-t-md'
            onClick={() => this.props.history.push('/auth/login')}
          >
            Back to login
          </div>
        </div>
      </div>
    )
  }
}

export default ForgotPasswordSuccess
